import { Collapse } from '@ksyos/design-system';
import { useState } from 'react';
import type { AdminProcess } from './adminProcessDetailsTypes';
import { ReportCategories } from '../../../../common/enums/reportCategories';
import { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { DropdownLink, FormParagraph } from '../../elements/common';
import { FormLabel } from '../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../elements/forms/InputContainer';

interface IAdminProcessDetailsTechnicalStatusProps {
    adminProcess: AdminProcess;
}

export function AdminProcessDetailsTechnicalStatus(props: IAdminProcessDetailsTechnicalStatusProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    let lastDiagnosticReport;
    let intakeReport;
    let dischargeReport;
    if (props.adminProcess.diagnosticReports && props.adminProcess.diagnosticReports.length > 0) {
        lastDiagnosticReport = props.adminProcess.diagnosticReports[props.adminProcess.diagnosticReports.length - 1];
        intakeReport = props.adminProcess.diagnosticReports.find((dp) => dp.category === ReportCategories.intake);
        dischargeReport = props.adminProcess.diagnosticReports.find((dp) => dp.category === ReportCategories.discharge);
    }

    return (
        <>
            <DropdownLink
                labelLess={translateKey('processDetails.technicalStatus')}
                labelMore={translateKey('processDetails.technicalStatus')}
                onClick={() => setIsOpen(!isOpen)}
                open={isOpen}
            />

            <Collapse isOpen={isOpen}>
                <HorizontalFormGroupRead>
                    <FormLabel>{`${translateKey('common.status')} ${translateKey('request.request')}`}</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.adminProcess.status}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>

                <HorizontalFormGroupRead>
                    <FormLabel>{`${translateKey('common.status')} ${translateKey('procedure.procedure')}`}</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.adminProcess.procedure ? props.adminProcess.procedure.status : ''}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>

                {props.adminProcess.service.serviceType !== ServiceType.referral &&
                    props.adminProcess.service.serviceType !== ServiceType.referralSmall && (
                        <HorizontalFormGroupRead>
                            <FormLabel>{`${translateKey('common.status')} ${translateKey(
                                'diagnosticReport.diagnosticReport'
                            )}`}</FormLabel>
                            <InputContainer>
                                <FormParagraph>
                                    {lastDiagnosticReport ? lastDiagnosticReport.reviewStatus : ''}
                                </FormParagraph>
                            </InputContainer>
                        </HorizontalFormGroupRead>
                    )}

                {props.adminProcess.service.serviceType === ServiceType.referral && (
                    <>
                        <HorizontalFormGroupRead>
                            <FormLabel>{`${translateKey('common.status')} ${translateKey(
                                'diagnosticReport.intakeReport'
                            )}`}</FormLabel>
                            <InputContainer>
                                <FormParagraph>{intakeReport ? intakeReport.reviewStatus : ''}</FormParagraph>
                            </InputContainer>
                        </HorizontalFormGroupRead>

                        <HorizontalFormGroupRead>
                            <FormLabel>{`${translateKey('common.status')} ${translateKey(
                                'diagnosticReport.dischargeReport'
                            )}`}</FormLabel>
                            <InputContainer>
                                <FormParagraph>{dischargeReport ? dischargeReport.reviewStatus : ''}</FormParagraph>
                            </InputContainer>
                        </HorizontalFormGroupRead>
                    </>
                )}

                <HorizontalFormGroupRead>
                    <FormLabel>{`${translateKey('common.status')} ${translateKey('request.supervision')}`}</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.adminProcess.supervision ? props.adminProcess.supervision.status : ''}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>

                <HorizontalFormGroupRead>
                    <FormLabel>{`${translateKey('procedure.customControlStatus')} ${translateKey(
                        'common.status'
                    )}`}</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.adminProcess.procedure ? props.adminProcess.procedure.customControlStatus : ''}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            </Collapse>
        </>
    );
}
